import React from "react";

const NounProAppsList = ({ showCaptions }) => {
    const ulClasses = showCaptions
        ? "noun-pro-apps-list show-captions row margin-t-s margin-b-s"
        : "noun-pro-apps-list hide-captions";
    const columnClasses = showCaptions
        ? "column col-lg-6 col-md-6 col-sm-6 col-xs-6"
        : "column";

    return (
        <ul className={ulClasses}>
            <li className={columnClasses}>
                <ul>
                    <li className="app">
                        <img
                            src={require("../../img/mac_app/apple@2x.png")}
                            alt="Noun Project for Mac"
                            title="Noun Project for Mac"
                            title="Drag and drop from your desktop."
                            width="18"
                            height="18"
                        />
                        <span className="caption">Mac Users</span>
                    </li>
                    <li className="app">
                        <img
                            src={require("../../img/for_windows/appicon_illustrator@2x.png")}
                            alt="Noun Project for Adobe Illustrator"
                            title="Noun Project for Adobe Illustrator"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Adobe Illustrator</span>
                    </li>
                    <li className="app">
                        <img
                            src={require("../../img/for_windows/appicon_photoshop@2x.png")}
                            alt="Noun Project for Adobe Photoshop"
                            title="Noun Project for Adobe Photoshop"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Adobe Photoshop</span>
                    </li>
                    <li className="app">
                        <img
                            src={require("../../img/for_windows/appicon_indesign@2x.png")}
                            alt="Noun Project for Adobe InDesign"
                            title="Noun Project for Adobe InDesign"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Adobe InDesign</span>
                    </li>
                </ul>
            </li>
            <li className={columnClasses}>
                <ul>
                    <li className="app">
                        <img
                            src={require("../../img/for_windows/logo_slides_128px.png")}
                            alt="Noun Project for Google Slides"
                            title="Noun Project for Google Slides"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Google Slides</span>
                    </li>
                    <li className="app">
                        <img
                            src={require("../../img/for_windows/logo_docs_128px.png")}
                            alt="Noun Project for Google Docs"
                            title="Noun Project for Google Docs"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Google Docs</span>
                    </li>
                    <li className="app">
                        <img
                            src={require("../../img/for_windows/Microsoft_PowerPoint_2013_logo.svg")}
                            alt="Noun Project for Microsoft PowerPoint"
                            title="Noun Project for Microsoft PowerPoint"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Microsoft PowerPoint</span>
                    </li>
                    <li className="app">
                        <img
                            src={require("../../img/for_windows/Microsoft_Word_2013_logo.svg")}
                            alt="Noun Project for Microsoft Word"
                            title="Noun Project for Microsoft word"
                            width="18"
                            height="18"
                        />
                        <span className="caption">Microsoft Word</span>
                    </li>
                </ul>
            </li>
        </ul>
    );
};

export default NounProAppsList;
